//Lib 
import { mapState } from "vuex";

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Constant  
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { EXTRA_SERVICE_TYPE, ERROR_CODE_EXPAND_STORAGE_THRESHOLD } from "@/constant/extraService";

// Component  

export default {

    extends: baseExtraService,

    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    data() {

        return {
            storageThreshold: 0,
            note: null,
        };
    },

    mounted() {
        this.storageThreshold = this.user.storageThreshold / (1024 * 1024 * 1024);
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD);
        },
        //#endregion

        //#region Expand storage threshold send request
        send() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: EXTRA_SERVICE_TYPE.EXPAND_STORAGE_THRESHOLD,
                    storageThreshold: this.storageThreshold,
                    note: this.note,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.createRequest(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}